import { useEffect, useState } from 'react'
import { UGEStickerCategory, ugeStickerCategories } from '../types'

export function useStickerCategories(canSearchFavorites: boolean = false) {
    const [state, setState] = useState<UGEStickerCategory[]>([])

    useEffect(() => {
        if (canSearchFavorites) {
            setState([...ugeStickerCategories])
        } else {
            setState(ugeStickerCategories.filter((c) => c !== 'giphyfavorites'))
        }
    }, [canSearchFavorites])

    return state
}
